import {
    CASH_REQUISITION_CASHFORM_EDIT,
    CASH_REQUISITION_CASHFORM_NAVIGATE_TO_DETAIL_REVERSE,
    CASH_REQUISITION_CASHFORM_NAVIGATE_TO_DETAIL_TAB,
    CASH_REQUISITION_CASHFORM_RESET,
    CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME,
    CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_FAILURE,
    CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_REQUEST,
    CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_SUCCESS,
    CREATE_CASH_REQUISITION_FORM_DETAILS,
    CREATE_CASH_REQUISITION_FORM_DETAILS_FAILURE,
    CREATE_CASH_REQUISITION_FORM_DETAILS_REQUEST,
    CREATE_CASH_REQUISITION_FORM_DETAILS_SUCCESS,
    DELETE_CASH_REQUISITION_FORM_DETAILS_FAILURE,
    DELETE_CASH_REQUISITION_FORM_DETAILS_REQUEST,
    DELETE_CASH_REQUISITION_FORM_DETAILS_SUCCESS,
    FETCH_CASH_REQUISITION_CRFNO_FAILURE,
    FETCH_CASH_REQUISITION_CRFNO_REQUEST,
    FETCH_CASH_REQUISITION_CRFNO_SUCCESS,
    FETCH_CASH_REQUISITION_FAILURE,
    FETCH_CASH_REQUISITION_REPORT_FAILURE,
    FETCH_CASH_REQUISITION_REPORT_REQUEST,
    FETCH_CASH_REQUISITION_REPORT_SUCCESS,
    FETCH_CASH_REQUISITION_REQUEST,
    FETCH_CASH_REQUISITION_STYLES_SUCCESS,
    FETCH_CASH_REQUISITION_SUCCESS,
    FETCH_CASH_SUPPLIER_LIST2_SUCCESS,
    FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_FAILURE,
    FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_REQUEST,
    FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_SUCCESS,
    FETCH_SINGLE_CASH_REQUISITION_FORM_REQUEST,
    FETCH_SINGLE_CASH_REQUISITION_FORM_SUCCESS,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_CASH_REQUISITION,
    NAVIGATE_CASH_REQUISITION_DETAILS,
    RESET_CASH_REQUISITION_INVOICE_DATA,
    SET_TAB_NAME_CASH_REQUISITION_DATA,
    UPDATE_CASH_REQUISITION_FORM_DETAILS_FAILURE,
    UPDATE_CASH_REQUISITION_FORM_DETAILS_REQUEST,
    UPDATE_CASH_REQUISITION_FORM_DETAILS_SUCCESS
} from './cashRequisition.actionType';

export const CASH = 'cash';

let initialState = {
    loading: false,
    cashRequisitionFormList: [],
    cashForm: {
        fldTransactionMode: "C",
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1,
        fldFKSupplier: 0
    },
    // cashFormEdit: {},
    selectedRow: {},
    cashFormSingleData: [],
    CashDetailsId: '',
    detailsId: '',
    activeKey: 1,
    DeleteFormData: '',
    gridPageIndex: 0,
    isCashRequisition: false,
    cashRequisitionSelectedValue: null,
    CashInvoiceDataV2: [],
    cashStyle: [],
    deliveryList: [],
    headerSearchCall: true,
    cashInvoiceMultiple: [],
    cashRequisitionReport: [],
    renderTab: 'cashEntry'
};

export let cashRequisitionReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CASH_REQUISITION_REQUEST:
        case FETCH_CASH_REQUISITION_CRFNO_REQUEST:
        case CREATE_CASH_REQUISITION_FORM_DETAILS_REQUEST:
        case FETCH_SINGLE_CASH_REQUISITION_FORM_REQUEST:
        case UPDATE_CASH_REQUISITION_FORM_DETAILS_REQUEST:
        case DELETE_CASH_REQUISITION_FORM_DETAILS_REQUEST:
        case CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_REQUEST:
        case FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_REQUEST:
        case FETCH_CASH_REQUISITION_REPORT_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_CASH_REQUISITION_SUCCESS:
            return {
                ...state,
                loading: false,
                cashRequisitionFormList: updatePayload,
                cashForm: {
                    startDate: state.cashForm.startDate,
                    endDate: state.cashForm.endDate,
                    unitId: state.cashForm.unitId
                },

            };
        case FETCH_CASH_REQUISITION_CRFNO_SUCCESS:
            return {
                ...state,
                loading: false,
                CashDetailsId: updatePayload
            };
        case FETCH_CASH_REQUISITION_STYLES_SUCCESS:
            return {
                ...state,
                loading: false,
                cashStyle: updatePayload
            };
        case FETCH_CASH_SUPPLIER_LIST2_SUCCESS:
            return {
                ...state,
                loading: false,
                deliveryList: updatePayload
            };
        case CREATE_CASH_REQUISITION_FORM_DETAILS:
            return {
                ...state,
                loading: false,
                cashForm: {
                    ...state.cashForm,
                    [payload.key]: payload.value
                },

            };
        case CREATE_CASH_REQUISITION_FORM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                // cashForm:updatePayload,
                detailsId: updatePayload
            };

        case FETCH_SINGLE_CASH_REQUISITION_FORM_SUCCESS:
            return {
                ...state,
                loading: false,
                cashForm: {
                    ...updatePayload,
                    startDate: state.cashForm.startDate,
                    endDate: state.cashForm.endDate,
                    unitId: state.cashForm.unitId
                },
                selectedRow: updatePayload,
                activeKey: 1,

            };

        case UPDATE_CASH_REQUISITION_FORM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                cashForm: {
                    startDate: state.cashForm.startDate,
                    endDate: state.cashForm.endDate,
                    unitId: state.cashForm.unitId,
                },

                detailsId: ''
            };
        case DELETE_CASH_REQUISITION_FORM_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                DeleteFormData: updatePayload
            };

        case CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_SUCCESS:
            return {
                ...state,
                loading: false,
                CashInvoiceDataV2: updatePayload,
                activeKey: 3
            };
        case FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                cashInvoiceMultiple: updatePayload
            };
        case RESET_CASH_REQUISITION_INVOICE_DATA:
            return {
                ...state,
                loading: false,
                cashInvoiceMultiple: []
            };
        case FETCH_CASH_REQUISITION_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                cashRequisitionReport: updatePayload
            };
        case FETCH_CASH_REQUISITION_FAILURE:
        case FETCH_CASH_REQUISITION_CRFNO_FAILURE:
        case CREATE_CASH_REQUISITION_FORM_DETAILS_FAILURE:
        case UPDATE_CASH_REQUISITION_FORM_DETAILS_FAILURE:
        case DELETE_CASH_REQUISITION_FORM_DETAILS_FAILURE:
        case CASH_REQUISITION_FORMS_OF_REQUISITOR_NAME_FAILURE:
        case FETCH_MULTIPLE_CASH_REQUISITION_INVOICE_FAILURE:
        case FETCH_CASH_REQUISITION_REPORT_FAILURE:
            return {
                ...state,
                loading: false
            };
        case CASH_REQUISITION_CASHFORM_RESET:
            return {
                ...state,
                cashForm: {
                    fldTransactionMode: "C",
                    startDate: state.cashForm.startDate,
                    endDate: state.cashForm.endDate,
                    unitId: state.cashForm.unitId,
                    fldFKSupplier: 0
                },
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_CASH_REQUISITION_DETAILS:
            return {
                ...state,
                isCashRequisition: true,
                loading: false,
                cashRequisitionSelectedValue: updatePayload.cashRequisitionSelectedValue
            };
        case NAVIGATE_CASH_REQUISITION:
            return {
                ...state,
                isCashRequisition: false
            };
        case CASH_REQUISITION_CASHFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                cashForm: updatePayload,
                activeKey: 2
            };
        case CASH_REQUISITION_CASHFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                // cashForm: {},
                cashForm: {
                    fldTransactionMode: "C",
                    startDate: state.cashForm.startDate,
                    endDate: state.cashForm.endDate,
                    unitId: state.cashForm.unitId
                },
                cashRequisitionSelectedValue: {},
                detailsId: '',
                activeKey: 1
            };


        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case SET_TAB_NAME_CASH_REQUISITION_DATA:
            return {
                ...state,
                loading: false,
                renderTab: payload
            }

        default:
            return state;
    }
};
